export const API_URL = {
  // Auth
  LOG_IN: "v1/admin/login/sendOtp",
  VERIFY_OTP: "v1/admin/login/verifyOtp",
  LOGOUT: "v1/user/logout",

  // Profile Category
  ADD_PROFILE_CATEGORY: "v1/profileCategory/add",
  UPDATE_PROFILE_CATEGORY: "v1/profileCategory/update",
  DELETE_PROFILE_CATEGORY: "v1/profileCategory/delete",
  GET_PROFILE_CATEGORY: "v1/profileCategory/get",
  GET_PROFILE_CATEGORY_LIST: "v1/profileCategory/getList",

  // Project Category
  ADD_PROJECT_CATEGORY: "v1/projectCategory/add",
  UPDATE_PROJECT_CATEGORY: "v1/projectCategory/update",
  DELETE_PROJECT_CATEGORY: "v1/projectCategory/delete",
  GET_PROJECT_CATEGORY: "v1/projectCategory/get",
  GET_PROJECT_CATEGORY_LIST: "v1/projectCategory/getList",

  // Role Type
  ADD_ROLE_TYPE: "v1/roleType/add",
  UPDATE_ROLE_TYPE: "v1/roleType/update",
  DELETE_ROLE_TYPE: "v1/roleType/delete",
  GET_ROLE_TYPE: "v1/roleType/get",
  GET_ROLE_TYPE_LIST: "v1/roleType/getList",

  // Common for kyc
  UPLOAD_KYC: "v1/admin/kyc/add",
  GET_USERS_KYC: "v1/admin/getUsersKyc",
  MARK_KYC_COMPLETE: "v1/admin/markKycComplete",
  ADMIN_ADD_KYC: "v1/admin/addKyc",

  // Common for users
  GET_USERS_LIST: "v1/admin/getUsersList",
  GET_PROFILE_BY_ID: "v1/admin/getUser",
  ASSIGN_LABEL: "v1/admin/assignLabel",
  MARK_USER_VERIFIED: "v1/admin/markUserVerified",
  DELETE_USER_PROFILES: "v1/admin/deleteUser",
  ADD_USER: "v1/admin/addUser",
  UPDATE_USER: "v1/admin/updateUser",
  GET_USER_AUDITIONS: "v1/admin/getAuditionsForUser",
  GET_USERS_MEDIA: "v1/media/getMediaList",
  UPLOAD_PROFILE_PIC: "v1/admin/upload/profilePic",

  MARK_USER_SHOWCASE: "v1/admin/markUserShowcase",

  // Audition Panel
  GET_AUDITIONS_LIST: "v1/admin/getAuditionsList",
  GET_AUDITION_BY_ID: "v1/admin/getAudition",
  UPDATE_JOB: "v1/admin/updateJob",
  MARK_JOB_VERIFIED: "v1/admin/markJobVerified",
  DELETE_JOB: "v1/admin/deleteJob",
  ASSIGN_JOB_LABEL: "v1/admin/assignLabel",

  GET_LOCATION_LIST: "v1/location/getList",
  GET_REPORT_TYPE_LIST: "v1/report/getList",
  REPORT_PROFILE: "v1/report/profile",
  REPORT_JOB: "v1/report/job",

  // Project Panel
  // ADD_PROJECT: "admin/addProject",
  ADD_PROJECT: "v2/project/add",
  UPDATE_PROJECT: "v1/admin/updateProject",
  GENERATE_PROJECT: "v2/project/generate",

  // Label
  ADD_LABEL: "v1/label/add",
  UPDATE_LABEL: "v1/label/update",
  DELETE_LABEL: "v1/label/delete",
  GET_LABEL: "v1/label/get",
  GET_LABEL_LIST: "v1/label/getList",

  // Notification
  ADD_NOTIFICATION: "v1/notification/add",
  SEND_NOTIFICATION: "v1/admin/sendNotification",

  // constant
  GET_EXPERIENCE_CATEGORY: "v1/constant/getExperienceCategory",
  GET_EXPERIENCE_TYPE_LIST: "v1/constant/getExperienceYears",

  // Fames
  ADD_FAMES: "v1/admin/addFames",
};

export const StatusCodes = {
  SUCCESS: 200,
  SUCCESS_WAIT: 210,
  NO_DATA_FOUND: 412,
  VALUE_NOT_ALLOWED: 413,
  AUTH_FAILED: 401,
  BAD_REQUEST: 400,
  INVALID_ACCESS: 403,
  INCORRECT_URL: 404,
  METHOD_NOT_SUPPORTED: 405,
  NOT_ACCEPTABLE: 406,
  REQUEST_TIMEOUT: 408,
  REQUEST_CANCELLED: 499,
  SERVER_ERROR: 500,
  DUPLICATE_DATA: 420,
  UNSUPPORTED_MEDIA_TYPE: 415,
};

export const AxiosError = {
  code: StatusCodes.REQUEST_TIMEOUT,
  message: "Request Timeout!!",
  description: "Request Timeout of 15 seconds!",
};
